import TrackableRedirect from '@components/TrackingRedirect';

const TheGame = () => {
  return <TrackableRedirect to="/ai-team-rating" />;
};

export default TheGame;
